/* eslint-disable no-useless-escape */
import { API_URL, API_URL_DEV, INTERNAL_REQUESTS_TOKEN } from "../Constants";

export const parseJSONResponse = (response) => {
  return new Promise((resolve) => {
    return response
      .json()
      .then((json) =>
        resolve({
          status: response.status,
        ok: response.ok,
          json,
        })
      )
      .catch((error) =>
        resolve({
          status: response.status,
          ok: false,
          json: {
            message: response.statusText,
          },
        })
      );
  });
};

export const asyncCheck = async (field, value) => {
  const body = {};

  if (field === 'email') body.email = value ? value.trim() : "";
  else if (field === 'username') body.username = value ? value.trim() : "";

  try {
    const response = await fetch(`${API_URL}/account/check`, {
      credentials: 'include', method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
    });

    const result = await response.json();
    return result;
  } catch (error) {
    console.error(error);
    return error
  }
};

export const createDemoAccount = async (data) => {
  try {
    const response = await fetch(`${API_URL}/account/demoAccount/create`, {
      credentials: 'include', method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })

    const result = await response.json();

    if (result.ok) {
      return result
    } else {
      if (result.message && result.message === 'Exist Client') {
        return { ok: false, message: 'This email is already registered with one of our Group of Comapnies.\n Please use an alternative email to create a demo account' }
      }
    }

    return result;
  } catch (error) {
    console.error(error);
    return { ok: false, error}
  }
}

export const validateEmail = (email) => {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
}

// returns ordinal suffix of a number in string
export const getNumberWithOrdinal = (n) => {
  const s = ['th', 'st', 'nd', 'rd'], v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
}

export const isPopUpAllowed = async () => {
  try {
    const popup = window.open('https://www.google.com');
    if (popup == null || typeof (popup) === 'undefined') return false
  } catch (error) {

  }
}

function _hasPopupBlocker(poppedWindow) {
  var result = false;

  try {
    if (typeof poppedWindow == 'undefined') {
      // Safari with popup blocker... leaves the popup window handle undefined
      result = true;
    }
    else if (poppedWindow && poppedWindow.closed) {
      // This happens if the user opens and closes the client window...
      // Confusing because the handle is still available, but it's in a "closed" state.
      // We're not saying that the window is not being blocked, we're just saying
      // that the window has been closed before the test could be run.
      result = false;
    }
    else if (poppedWindow && poppedWindow.test) {
      // This is the actual test. The client window should be fine.
      result = false;
    }
    else {
      // Else we'll assume the window is not OK
      result = true;
    }

  } catch (err) {
    console.warn("Could not access popup window", err);
  }

  return result;
}

export const openNewWindow = (paypal, w = 580, h = 540) => {
  // Fixes dual-screen position                             Most browsers      Firefox
  const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : window.screenX;
  const dualScreenTop = window.screenTop !== undefined ? window.screenTop : window.screenY;

  const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : window.screen.width;
  const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : window.screen.height;

  const systemZoom = width / window.screen.availWidth;
  const left = (width - w) / 2 / systemZoom + dualScreenLeft;
  const top = (height - h) / 2 / systemZoom + dualScreenTop;
  const text = paypal ? 'TVI - PayPal Authorize' : 'TVI - Crypto Authorize';
  const newWindow = window.open('', text,
    `
    scrollbars=yes,
    width=${w / systemZoom}, 
    height=${h / systemZoom}, 
    top=${top}, 
    left=${left}
    `
  );

  if (!_hasPopupBlocker(newWindow)) return { error: '_Please turn off your pop-up blocker to pay via PayPal' };

  if (newWindow == null || typeof (newWindow) === 'undefined') return { error: '_Please turn off your pop-up blocker to pay via PayPal' };

  if (window.focus) newWindow.focus();

  return newWindow;
}

export const ValidateEmail = (mail) => {
  if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(mail)) {
    return true
  }
  return false
}

export const getMyOrder = () => new Promise(async (resolve, reject) => {
  try {
    const response = await fetch(`${API_URL}/my/order`, { credentials: 'include' });

    resolve(await response.json());
  } catch (error) {
    console.error(error)
    resolve({ ok: false, message: error.message || 'Unknown Error', status: error.status || 500 });
  }
});

export const convertTVIUserToTVTSC = async (data) => {
  try {
    const response = await fetch(`${API_URL}/account/demoAccount/convert`, {
      credentials: 'include', method: 'POST',
      // eslint-disable-next-line no-useless-escape
      headers: { 'Content-Type': 'application/json', 'tvi-internal-request': INTERNAL_REQUESTS_TOKEN},
      body: JSON.stringify(data),
    });

    const { ok, status, ...rest } = await response.json();

    if (ok) return { ok: true };
    else return { ok: false, msg: rest };
  } catch (error) {
    console.error(error);
    return { ok: false, msg: error }
  }
};